import React from "react";

export default function BulkUpdateModal({
  open,
  bulkUpdateData,
  setBulkUpdateData,
  onClose,
  onSubmit,
  loading,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-xl p-6 max-w-lg w-full mx-4 shadow-xl">
        <h3 className="text-lg font-semibold text-gray-900 mb-5">
          Bulk Update Product Sizes
        </h3>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Name
            </label>
            <input
              type="text"
              value={bulkUpdateData.name}
              onChange={(e) =>
                setBulkUpdateData((prev) => ({
                  ...prev,
                  name: e.target.value,
                }))
              }
              placeholder="Enter name"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-500"
            />
          </div>

          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Width
              </label>
              <input
                type="number"
                value={bulkUpdateData.width}
                onChange={(e) =>
                  setBulkUpdateData((prev) => ({
                    ...prev,
                    width: e.target.value,
                  }))
                }
                placeholder="Width"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-500"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Height
              </label>
              <input
                type="number"
                value={bulkUpdateData.height}
                onChange={(e) =>
                  setBulkUpdateData((prev) => ({
                    ...prev,
                    height: e.target.value,
                  }))
                }
                placeholder="Height"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-500"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Unit
            </label>

            <select
              value={bulkUpdateData.unit}
              onChange={(e) =>
                setBulkUpdateData((prev) => ({
                  ...prev,
                  unit: e.target.value,
                }))
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-500"
            >
              <option value="">Select Unit</option>
              <option value="mm">MM</option>
              <option value="cm">CM</option>
              <option value="inch">Inch</option>
              <option value="ft">Feet</option>
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Default Layout
            </label>

            <select
              value={bulkUpdateData.default_layout}
              onChange={(e) =>
                setBulkUpdateData((prev) => ({
                  ...prev,
                  default_layout: e.target.value,
                }))
              }
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-500"
            >
              <option value="">Select Layout</option>
              <option value="grid">Grid</option>
              <option value="brick">Brick</option>
              <option value="stack">Stack</option>
            </select>
          </div>
        </div>

        <div className="flex gap-3 justify-end mt-6">
          <button
            type="button"
            onClick={onClose}
            disabled={loading}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={onSubmit}
            disabled={loading}
            className="px-4 py-2 bg-slate-800 text-white rounded-lg hover:bg-slate-900 transition-colors disabled:opacity-50"
          >
            {loading ? "Updating..." : "Update"}
          </button>
        </div>
      </div>
    </div>
  );
}